// extracted by css-extract-rspack-plugin
export default {"two_columns_wrapper":"vxi7z","twoColumnsWrapper":"vxi7z","init_screen_override":"T9SVX","initScreenOverride":"T9SVX","#":"Rw_mp"};